<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
      </section>

      <v-form v-model="valid">

        <template v-if="isAllowed('見積・請求')">

          <h3>販売設定</h3>
          <v-row no-gutters>
            <v-col cols="2" class="pa-2">
              <p class="label">販売状態</p>
              <toggle-button
                v-model="editedItem.saleEnabled"
                :labels="{checked: '販売中', unchecked: '販売停止'}"
                color="#0277bd"
                :value="editedItem.saleEnabled"
                :sync="true" :width="100" :height="30" :font-size="14" />
            </v-col>
            <v-col cols="2" class="pa-2">
              <v-text-field
                ref="orderPrefix"
                label="消費税率"
                type="number"
                v-model="editedItem.consumptionTax"
                :rules="[rules.integer, rules.min0, rules.max100]"
                append-icon="fas fa-percentage"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
          </v-row>
        
          <h3 class="mt-5">伝票No設定</h3>
          <v-row no-gutters>
            <v-col cols="12" md="2" class="pa-2">
              <v-text-field
                ref="orderPrefix"
                label="前置文字列"
                v-model="editedItem.orderPrefix"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="pa-2">
              <v-text-field
                ref="orderDateFormat"
                label="日付フォーマット"
                v-model="editedItem.orderDateFormat"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="pa-2">
              <v-text-field
                ref="orderNoDigit"
                type="number"
                label="連番桁数"
                v-model="editedItem.orderNoDigit"
                :rules="[rules.integer, rules.min0]"
                outlined hide-details="auto">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="pa-2">
              <v-text-field
                label="伝票No サンプル"
                v-model="orderNoSample"
                outlined hide-details="auto" disabled>
              </v-text-field>
            </v-col>
          </v-row>
          <ul class="attention">
            <li>ソニーペイメントの決済サービス「e-scott」をご利用の場合、伝票桁数が <span class="font-weight-bold">7桁固定</span> に制限されておりますのでご注意ください。</li>
          </ul>
        </template>

        <h3 class="mt-5">配信元メール設定</h3>
        <v-row no-gutters>
          <v-col cols="12" md="3" class="pa-2">
            <v-text-field
              ref="sendMailAddress"
              label="メールアドレス"
              v-model="editedItem.sendMailAddress"
              :rules="[rules.email]"
              outlined hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3" class="pa-2">
            <v-text-field
              ref="sendMailAccount"
              label="アカウント"
              v-model="editedItem.sendMailAccount"
              :rules="[]"
              outlined hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="pa-2">
            <v-text-field
              ref="sendMailPassword"
              label="パスワード"
              v-model="editedItem.sendMailPassword"
              :rules="[]"
              outlined hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="pa-2">
            <v-text-field
              ref="sendMailServer"
              label="送信メールサーバー"
              v-model="editedItem.sendMailServer"
              :rules="[]"
              outlined hide-details="auto">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="pa-2">
            <v-text-field
              ref="sendMailPort"
              label="送信メールポート"
              v-model="editedItem.sendMailPort"
              :rules="[]"
              outlined hide-details="auto">
            </v-text-field>
          </v-col>
        </v-row>

        <h3 class="mt-5">配信先メール設定</h3>
        <v-row no-gutters>
          <v-col cols="12" md="6" class="pa-2">
            <v-text-field
              ref="facilityReserveMail"
              label="施設予約時"
              v-model="editedItem.facilityReserveMail"
              :rules="[rules.email]"
              outlined hide-details="auto">
            </v-text-field>
          </v-col>
        </v-row>

        <h3 class="mt-5">雇用形態設定</h3>
        <v-row no-gutters>
          <v-col cols="12" md="6" class="pa-2">
            <v-text-field
              ref="employmentType"
              label="雇用形態"
              v-model="editedItem.employmentType"
              :rules="[]"
              hint="選択可能な雇用形態をカンマ区切りで指定して下さい"
              outlined hide-details="auto">
            </v-text-field>
          </v-col>
        </v-row>

        <template v-if="isAllowed('日報')">
          <h3 class="mt-5">時間単価設定</h3>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="pa-2">
              <v-text-field
                ref="unitPrice"
                label="時間単価"
                v-model="editedItem.unitPrice"
                :rules="[]"
                hint="選択可能な時間単価をカンマ区切りで指定して下さい"
                outlined>
              </v-text-field>
            </v-col>
          </v-row>

          <h3 class="mt-5">労務時間計算設定</h3>
          <v-row no-gutters>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="normalTimeMax"
                label="見込残業時間"
                v-model="editedItem.normalOverTime"
                :rules="[]"
                hint="設定時間内は見込残業として計上します"
                suffix="時間"
                outlined>
              </v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="normalOverTimeMax"
                label="通常残業時間"
                v-model="editedItem.exceedOverTime"
                :rules="[]"
                hint="設定時間内は通常残業として計上します"
                suffix="時間"
                outlined>
              </v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="normalOverTimeAdd"
                label="通常残業加算"
                v-model="editedItem.normalOverTimeAdd"
                :rules="[]"
                hint="通常残業手当のパーセンテージを設定"
                suffix="％"
                outlined>
              </v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="exceedOverTimeAdd"
                label="超過残業加算"
                v-model="editedItem.exceedOverTimeAdd"
                :rules="[]"
                hint="超過残業手当のパーセンテージを設定"
                suffix="％"
                outlined>
              </v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="midnightAdd"
                label="深夜加算"
                v-model="editedItem.midnightAdd"
                :rules="[]"
                hint="深夜手当のパーセンテージを設定"
                suffix="％"
                outlined>
              </v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="holidayAdd"
                label="休日加算"
                v-model="editedItem.holidayAdd"
                :rules="[]"
                hint="休日手当のパーセンテージを設定"
                suffix="％"
                outlined>
              </v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="startTime"
                label="始業時間"
                type="time"
                v-model="editedItem.startTime"
                :rules="[rules.step15]"
                outlined>
              </v-text-field>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-combobox
                ref="closing"
                label="締め日"
                v-model="editedItem.closing"
                :items="closing"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('closing')"
                readonly outlined hide-details>
              </v-combobox>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-combobox
                ref="calcMonth"
                label="起算月"
                v-model="editedItem.calcMonth"
                :items="months"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('calcMonth')"
                readonly outlined hide-details>
              </v-combobox>
            </v-col>
          </v-row>

          <h3 class="mt-5">日報設定</h3>
          <v-row no-gutters>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="dialyLockDays"
                label="日報ロック日数"
                v-model="editedItem.dialyLockDays"
                :rules="[rules.integer]"
                hint="設定日数以前の日報は作成できません"
                suffix="日"
                outlined>
              </v-text-field>
            </v-col>
          </v-row>

          <h3 class="mt-5">有給休暇設定</h3>
          <v-row no-gutters>
            <v-col cols="6" md="2" class="pa-2">
              <v-combobox
                ref="paidMonth"
                label="有給付与月"
                v-model="editedItem.paidMonth"
                :items="months"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('paidMonth')"
                readonly outlined hide-details>
              </v-combobox>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-combobox
                ref="paidDay"
                label="有給付与日"
                v-model="editedItem.paidDay"
                :items="closing"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('paidDay')"
                readonly outlined hide-details>
              </v-combobox>
            </v-col>
            <v-col cols="6" md="2" class="pa-2">
              <v-text-field
                ref="maxDaysOfPaidTime"
                label="時間有給取得可能日数"
                v-model="editedItem.maxDaysOfPaidTime"
                :rules="[rules.integer, rules.min0]"
                type="number"
                min="0"
                hint="時間有給として使用可能な最大日数を指定します"
                suffix="日"
                outlined>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" md="3" class="pa-2">
              <v-data-table 
                :headers="paidHeaders" 
                :items="editedItem.paid"
                @click:row="(...args) => editPaid(...args, 'paid')"
                dense disable-pagination hide-default-footer>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>通常勤務</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click.stop="openPaid('paid')">追加</v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small @click.stop="removePaid(item, 'paid')">fas fa-times</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" md="3" class="pa-2">
              <v-data-table 
                :headers="paidHeaders" 
                :items="editedItem.week1Paid"
                @click:row="(...args) => editPaid(...args, 'week1Paid')"
                dense disable-pagination hide-default-footer>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>週1日勤務</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click.stop="openPaid('week1Paid')">追加</v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small @click.stop="removePaid(item, 'week1Paid')">fas fa-times</v-icon>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="6" md="3" class="pa-2">
              <v-data-table 
                :headers="paidHeaders" 
                :items="editedItem.week2Paid"
                @click:row="(...args) => editPaid(...args, 'week2Paid')"
                dense disable-pagination hide-default-footer>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>週2日勤務</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click.stop="openPaid('week2Paid')">追加</v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small @click.stop="removePaid(item, 'week2Paid')">fas fa-times</v-icon>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="6" md="3" class="pa-2">
              <v-data-table 
                :headers="paidHeaders" 
                :items="editedItem.week3Paid"
                @click:row="(...args) => editPaid(...args, 'week3Paid')"
                dense disable-pagination hide-default-footer>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>週3日勤務</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click.stop="openPaid('week3Paid')">追加</v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small @click.stop="removePaid(item, 'week3Paid')">fas fa-times</v-icon>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="6" md="3" class="pa-2">
              <v-data-table 
                :headers="paidHeaders" 
                :items="editedItem.week4Paid"
                @click:row="(...args) => editPaid(...args, 'week4Paid')"
                dense disable-pagination hide-default-footer>
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>週4日勤務</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark class="mb-2" @click.stop="openPaid('week4Paid')">追加</v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-icon small @click.stop="removePaid(item, 'week4Paid')">fas fa-times</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </template>

        <div class="text-right pa-2">
          <v-btn color="primary" @click.stop="save" :loading="saving" :disabled="!valid" depressed>
            <v-icon left>fas fa-save</v-icon>更新
          </v-btn>
        </div>
      </v-form>

      <v-dialog v-model="paidDialog" max-width="500px">
        <v-card>
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">勤続年数と付与日数の追加</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="paidValid">
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      ref="paidyear"
                      label="勤続年数"
                      v-model="paidItem.year"
                      :rules="[rules.required]"
                      type="number"
                      min="0"
                      outlined>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      ref="paiddays"
                      label="有給休暇付与日数"
                      v-model="paidItem.days"
                      type="number"
                      min="0"
                      :rules="[rules.required, rules.integer]"
                      outlined>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.stop="addPaid" :loading="saving" :disabled="!paidValid" depressed>
              <v-icon left>fas fa-save</v-icon>OK
            </v-btn>
            <v-btn @click="paidDialog = false" depressed>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { createAppOption, updateAppOption } from '../graphql/mutations'
import { listAppOptions } from '../graphql/queries'
import moment from 'moment'

export default {
  data() {
    return {
      search: '',
      loading: true,
      valid: false,
      saving: false,
      desserts: [],
      editedItem: {
        paid: [],
        week1Paid: [],
        week2Paid: [],
        week3Paid: [],
        week4Paid: [],
      },
      paidDialog: false,
      paidValid: false,
      paidType: null,
      paidIndex: -1,
      paidItem: {
        year: null,
        days: null,
      },
      paidHeaders: [
        { text: '勤続年数', align: 'start', value: 'year' },
        { text: '付与日数', align: 'start', value: 'days' },
        { text: '', align: 'start', value: 'actions', sortable: false, width: 30 },
      ],
    }
  },
  prop: {},
  mounted: async function() {
    //一覧 query
    const query = await API.graphql(graphqlOperation(listAppOptions, {
      filter: {
        tag: { eq: 'appSetting' }
      },
      limit: 100,
    }))
    for (const row of query.data.listAppOptions.items) {
      //if (!row.value) continue
      this.desserts.push(row)
      switch (row.name) {
        case 'saleEnabled':
          this.$set(this.editedItem, row.name, row.value == 'true' ? true : false)
          break
        case 'closing':
          this.$set(this.editedItem, row.name, this.closing.find(e => e.value === parseInt(row.value)))
          break
        case 'calcMonth':
          this.$set(this.editedItem, row.name, this.months.find(e => e.value === parseInt(row.value)))
          break
        case 'paidMonth':
          this.$set(this.editedItem, row.name, this.months.find(e => e.value === parseInt(row.value)))
          break
        case 'paidDay':
          this.$set(this.editedItem, row.name, this.closing.find(e => e.value === parseInt(row.value)))
          break
        case 'paid':
          this.$set(this.editedItem, row.name, JSON.parse(row.value).map(e => ({
            year: e.year,
            days: e.days,
          })))
          break
        case 'week1Paid':
          this.$set(this.editedItem, row.name, JSON.parse(row.value).map(e => ({
            year: e.year,
            days: e.days,
          })))
          break
        case 'week2Paid':
          this.$set(this.editedItem, row.name, JSON.parse(row.value).map(e => ({
            year: e.year,
            days: e.days,
          })))
          break
        case 'week3Paid':
          this.$set(this.editedItem, row.name, JSON.parse(row.value).map(e => ({
            year: e.year,
            days: e.days,
          })))
          break
        case 'week4Paid':
          this.$set(this.editedItem, row.name, JSON.parse(row.value).map(e => ({
            year: e.year,
            days: e.days,
          })))
          break
        default:
          this.$set(this.editedItem, row.name, row.value)
          break
      }
    }
    this.loading = false
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    orderNoSample() {
      const orderPrefix = this.editedItem.orderPrefix || ''
      const orderDateFormat = this.editedItem.orderDateFormat || null
      const orderNoDigit = this.editedItem.orderNoDigit || null

      const format = orderDateFormat ? moment().format(orderDateFormat) : ''
      const digit = orderNoDigit ? this.zeroPadding(1, parseInt(orderNoDigit)) : 1

      return orderPrefix + format + digit
    },
    closing() {
      const map = []

      for (let i=1; i<=28; i++) {
        map.push({ value: i, text: i + '日' })
      }
      map.push({ value: 0, text: '末日' })

      return map
    },
    months() {
      const map = []

      for (let i=1; i<=12; i++) {
        map.push({ value: i, text: i + '月' })
      }

      return map
    },
  },
  watch: {
    paidDialog(val) {
      val || this.paidClose()
    },
  },
  methods: {
    //保存
    async save() {
      try {
        this.saving = true
        for (const key in this.editedItem) {
          const data = {
            name: key,
            tag: 'appSetting',
            value: this.editedItem[key]
          }
          // 締め日
          if (key == 'closing') data.value = data.value.value
          // 起算月
          if (key == 'calcMonth') data.value = data.value.value
          // 有給付与月
          if (key == 'paidMonth') data.value = data.value.value
          // 有給付与日
          if (key == 'paidDay') data.value = data.value.value
          // 有給休暇取得設定
          if (key == 'paid') data.value = JSON.stringify(this.editedItem.paid)
          if (key == 'week1Paid') data.value = JSON.stringify(this.editedItem.week1Paid)
          if (key == 'week2Paid') data.value = JSON.stringify(this.editedItem.week2Paid)
          if (key == 'week3Paid') data.value = JSON.stringify(this.editedItem.week3Paid)
          if (key == 'week4Paid') data.value = JSON.stringify(this.editedItem.week4Paid)

          if (this.desserts.find(e => e.name == key)) {
            //更新
            await API.graphql(graphqlOperation(updateAppOption, {input: data}))
          } else {
            //新規
            await API.graphql(graphqlOperation(createAppOption, {input: data}))
          }
        }
        this.log({ type: this.$route.name, text: '設定を更新しました' })
        this.myAlert(this.$route.name + 'を保存しました', 'success')
        this.saving = false

      } catch (error) {
        this.myAlert(error.message)
        this.saving = false
      }

    },
    getValue(key) {
      return this.editedItem[key] || null
    },
    openPaid(type) {
      this.paidType = type
      this.paidDialog = true
    },
    addPaid() {
      if (this.paidIndex >= 0) {
        switch (this.paidType) {
          case 'paid':
            Object.assign(this.editedItem.paid[this.paidIndex], this.paidItem)
            break
          case 'week1Paid':
            Object.assign(this.editedItem.week1Paid[this.paidIndex], this.paidItem)
            break
          case 'week2Paid':
            Object.assign(this.editedItem.week2Paid[this.paidIndex], this.paidItem)
            break
          case 'week3Paid':
            Object.assign(this.editedItem.week3Paid[this.paidIndex], this.paidItem)
            break
          case 'week4Paid':
            Object.assign(this.editedItem.week4Paid[this.paidIndex], this.paidItem)
            break
        }

      } else {
        switch (this.paidType) {
          case 'paid':
            this.editedItem.paid.push({
              year: this.paidItem.year,
              days: this.paidItem.days,
            })
            break
          case 'week1Paid':
            this.editedItem.week1Paid.push({
              year: this.paidItem.year,
              days: this.paidItem.days,
            })
            break
          case 'week2Paid':
            this.editedItem.week2Paid.push({
              year: this.paidItem.year,
              days: this.paidItem.days,
            })
            break
          case 'week3Paid':
            this.editedItem.week3Paid.push({
              year: this.paidItem.year,
              days: this.paidItem.days,
            })
            break
          case 'week4Paid':
            this.editedItem.week4Paid.push({
              year: this.paidItem.year,
              days: this.paidItem.days,
            })
            break
        }
      }
      this.paidIndex = -1
      this.paidDialog = false
    },
    editPaid(item, event, type) {
      this.paidType = type
      switch (type) {
        case 'paid':
          this.paidIndex = this.editedItem.paid.indexOf(item)
          break
        case 'week1Paid':
          this.paidIndex = this.editedItem.week1Paid.indexOf(item)
          break
        case 'week2Paid':
          this.paidIndex = this.editedItem.week2Paid.indexOf(item)
          break
        case 'week3Paid':
          this.paidIndex = this.editedItem.week3Paid.indexOf(item)
          break
        case 'week4Paid':
          this.paidIndex = this.editedItem.week4Paid.indexOf(item)
          break
      }
      this.paidItem = Object.assign({}, item)
      this.paidDialog = true
    },
    removePaid(item, type) {
      switch (type) {
        case 'paid':
          this.editedItem.paid.splice(this.editedItem.paid.indexOf(item), 1)
          break
        case 'week1Paid':
          this.editedItem.week1Paid.splice(this.editedItem.week1Paid.indexOf(item), 1)
          break
        case 'week2Paid':
          this.editedItem.week2Paid.splice(this.editedItem.week2Paid.indexOf(item), 1)
          break
        case 'week3Paid':
          this.editedItem.week3Paid.splice(this.editedItem.week3Paid.indexOf(item), 1)
          break
        case 'week4Paid':
          this.editedItem.week4Paid.splice(this.editedItem.week4Paid.indexOf(item), 1)
          break
      }
      this.paidIndex = -1
    },
    paidClose() {
      this.$refs['paidyear'].reset()
      this.$refs['paiddays'].reset()
      this.paidValid = false
      this.paidType = null
      this.paidIndex = -1
    },
  },
  components: {

  },
}
</script>

<style lang='scss' scoped>

</style>
